import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addChannelClosureData,
  deleteChannelClosureData,
  fetchChannelClosureList,
  fetchChannelFilterClosureList,
  updateChannelClosureData,
} from "../../apis/channelClosure";

export const fetchClosureListData = createAsyncThunk(
  "closureList/fetchClosureList",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchChannelClosureList();
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },{
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.channelClosure.isDataFetched; // Adjust path based on your state structure
    }
  }
);

export const updateClosure = createAsyncThunk(
  "closureList/updateClosure",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        channelClosureId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateChannelClosureData(id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteClosure = createAsyncThunk(
  "closureList/deleteClosure",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteChannelClosureData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewClosureData = createAsyncThunk(
  "closureList/addNewClosure",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addChannelClosureData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const fetchFilterClosureListData = createAsyncThunk(
  "closureList/fetchFilterClosureList",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchChannelFilterClosureList();
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
